export const getSellerName = (seller) => seller?.sellerName || seller?.newSellerName;

// Counts are used only when the applied request had date filters and the API returned them
export const getCountsToUse = (counts, isCountsDateFiltered, hasDateFilter) => {
  const canUse = hasDateFilter && isCountsDateFiltered && Array.isArray(counts);
  return canUse ? counts : null;
};

const sumBy = (pairs, keyField) => {
  const totals = new Map();
  pairs.forEach((pair) => {
    const current = totals.get(pair[keyField]) || { count: 0, companyId: pair.companyId };
    totals.set(pair[keyField], { ...current, count: current.count + pair.recordCount });
  });
  return totals;
};

export const buildCompanyOptions = (companyList, counts) => {
  const totals = sumBy(counts, 'companyId');
  return companyList
    .filter((company) => totals.has(company.Id))
    .map((company) => ({ ...company, label: `${company.name} (${totals.get(company.Id).count})` }));
};

export const buildSellerOptions = (sellers, counts, selectedCompanies = []) => {
  const selectedIds = (selectedCompanies || []).map((company) => company.Id);
  const pairs = selectedIds.length
    ? counts.filter((pair) => selectedIds.includes(pair.companyId))
    : counts;
  const totals = sumBy(pairs, 'sellerId');
  const lookup = new Map(sellers.map((seller) => [seller.id, seller]));
  return [...totals.entries()]
    .filter(([sellerId]) => getSellerName(lookup.get(sellerId)))
    .map(([sellerId, { count, companyId }]) => {
      const seller = lookup.get(sellerId);
      return {
        ...seller,
        companyId: seller.companyId ?? companyId,
        value: sellerId,
        label: `${getSellerName(seller)} (${count})`,
      };
    })
    .sort((a, b) => a.label.localeCompare(b.label));
};

// Keep selected chips in sync with the current option labels (e.g. refreshed counts)
export const syncSelected = (selected, options) => {
  if (!Array.isArray(selected)) return selected;
  return selected.map((item) => options.find((option) => option.value === item.value) || item);
};
